module.exports = __webpack_public_path__ + "media/manage/deactivate-8f390c1d.svg";